import PropTypes from "prop-types";
import { translate } from "constants";

export default function CustomPlayButton({
  refVideo,
  setVideoIsPlaying,
  lang,
}) {
  const onClickPlay = () => {
    setVideoIsPlaying(true);
    if (refVideo?.current) {
      refVideo.current.replay();
      refVideo.current.toggleFullScreen();
      refVideo.current.mute(false);
    }
  };

  return (
    <button
      onClick={() => onClickPlay()}
      className="click_to_play"
      aria-label={translate("Watch Video", lang)}
    >
      {translate("Watch Video", lang)}
    </button>
  );
}

CustomPlayButton.propTypes = {
  refVideo: PropTypes.object,
  setVideoIsPlaying: PropTypes.func,
  lang: PropTypes.string,
};
